import NestedForm from 'stimulus-rails-nested-form'

export default class extends NestedForm {
  static values = {
    childIndexName: {
      type: String,
      default: 'NEW_RECORD'
    }
  }

  add(e) {
    e.preventDefault();
    const content = this.templateTarget.innerHTML.replace(new RegExp(this.childIndexNameValue, 'g'), new Date().getTime().toString());
    this.targetTarget.insertAdjacentHTML("beforebegin", content);
  }

}